import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from '../../app.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgxSpinnerModule } from 'ngx-spinner';


import { EventEmitterService } from '../../services/shared/event-emitter.service';

import { DeleteModalComponent } from './modals/delete-modal/delete-modal.component';
import { TableComponent } from './tables/table/table.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { TableActionDirective } from 'src/app/directives/table-action.directive';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PrefilledModalComponent } from './modals/prefilled-modal/prefilled-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrandAddEditModalComponent } from './modals/brand-add-edit-modal/brand-add-edit-modal.component';
import { AddZoneSeatsComponent } from './modals/add-zone-seats/add-zone-seats.component';
import { AddZoneTablesComponent } from './modals/add-zone-tables/add-zone-tables.component';
import { AddReservationTypeComponent } from './modals/add-reservation-type/add-reservation-type.component';
import { SnoozeReservationModalComponent } from './modals/snooze-reservation-modal/snooze-reservation-modal.component';
import { AddOffersModalComponent } from './modals/add-offers-modal/add-offers-modal.component';
import { BookingDetailsModalComponent } from './modals/booking-details-modal/booking-details-modal.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { RefundModalComponent } from './modals/refund-modal/refund-modal.component';
import { CommissionModalComponent } from './modals/commission-modal/commission-modal.component';
import { InvoiceGenerateModalComponent } from './modals/invoice-generate-modal/invoice-generate-modal.component';
import { InvoiceCompleteModalComponent } from './modals/invoice-complete-modal/invoice-complete-modal.component';
import { FileViewerModalComponent } from './modals/file-viewer-modal/file-viewer-modal.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
  declarations: [
    DeleteModalComponent,
    TableComponent,
    TableActionDirective,
    PageNotFoundComponent,
    PrefilledModalComponent,
    BrandAddEditModalComponent,
    AddZoneSeatsComponent,
    AddZoneTablesComponent,
    AddReservationTypeComponent,
    SnoozeReservationModalComponent,
    AddOffersModalComponent,
    BookingDetailsModalComponent,
    RefundModalComponent,
    CommissionModalComponent,
    InvoiceGenerateModalComponent,
    InvoiceCompleteModalComponent,
    FileViewerModalComponent
  ],
  imports: [
    CommonModule,
    NgxSkeletonLoaderModule,
    UiSwitchModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule,
    BsDatepickerModule.forRoot(),
  ],
  exports: [
    DeleteModalComponent,
    TableComponent,
    PrefilledModalComponent,
    BrandAddEditModalComponent,
    AddZoneSeatsComponent,
    AddZoneTablesComponent,
    AddReservationTypeComponent,
    SnoozeReservationModalComponent,
    AddOffersModalComponent,
    BookingDetailsModalComponent,
    RefundModalComponent,
    CommissionModalComponent,
    InvoiceGenerateModalComponent,
    InvoiceCompleteModalComponent,
    FileViewerModalComponent
  ],
  providers: [EventEmitterService],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
